import { loadState, saveState } from './localStore';
import { TOKEN_KEY } from '../constants';
export var getToken = function getToken() {
  return loadState(TOKEN_KEY) || null;
};
export var saveToken = function saveToken(token) {
  return saveState(TOKEN_KEY, token);
};
export var getPayload = function getPayload(token) {
  var payload = token.split('.')[1];
  return JSON.parse(atob(payload));
};
export var getTokenExpirationTime = function getTokenExpirationTime(token) {
  var exp;

  try {
    exp = getPayload(token).exp;
  } catch (error) {
    console.error('The JWT token is not in the expected format', error);
    return exp;
  }

  return exp;
};
/**
 * Checks if a users JWT token has expired.
 */

export var hasTokenExpired = function hasTokenExpired() {
  var token = getToken();
  if (!token) return true;
  var exp = getTokenExpirationTime(token);
  var now = Math.floor(Date.now() / 1000);
  var hasExpired = exp < now;
  return hasExpired;
};
export default {
  hasTokenExpired: hasTokenExpired,
  getTokenExpirationTime: getTokenExpirationTime,
  getToken: getToken
};